import { Component, h, Host } from '@stencil/core';
import { theme } from '@eventstore-ui/theme';

/**
 * Displays Issues illustration.
 * @part illustration - The root svg of the illustration.
 */
@Component({
    tag: 'es-illustration-issues',
    styleUrl: 'issues.css',
    shadow: true,
})
export class EsIllustrationIssues {
    render() {
        const isDark = theme.isDark();

        return (
            <Host dark={isDark} light={!isDark}>
                {isDark ? this.renderDark() : this.renderLight()}
            </Host>
        );
    }

    renderLight() {
        return (
            <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 786 844"
                aria-hidden="true"
                width="100%"
                height="100%"
                focusable="false"
                role="img"
                part="illustration"
            >
                <defs>
                    <linearGradient
                        id="issues_b"
                        x1="936.2"
                        x2="663.2"
                        y1="50.8"
                        y2="410.1"
                        gradientTransform="matrix(1 0 0 -1 -207 642)"
                        gradientUnits="userSpaceOnUse"
                    >
                        <stop offset=".3" stop-color="#bbdefb" />
                        <stop offset="1" stop-color="#fff" />
                    </linearGradient>
                    <linearGradient
                        id="issues_c"
                        x1="570.5"
                        x2="387"
                        y1="359.7"
                        y2="601.2"
                        gradientTransform="matrix(1 0 0 -1 -207 642)"
                        gradientUnits="userSpaceOnUse"
                    >
                        <stop offset="0" stop-color="#bbdefb" />
                        <stop offset="1" stop-color="#fff" />
                    </linearGradient>
                </defs>
                <path
                    fill="#bbdefb"
                    d="m557 703.4 150.1-91.1-133.7-77-26.9-77.8-102.8 62.4L381 322.5l-86.2 52.3-65.8-38-150.1 91.1L275 695.3l141.3 68 47.1-20c1.3 1 2.6 1.9 4 2.7 6.1 3.6 11.7 3.9 16.6 1.1l70.7-42.7 2.3-1Z"
                />
                <path
                    fill="#fff"
                    fill-rule="evenodd"
                    d="M335.1 653.4c-3.2 6.6-9 7.5-17.1 2.8s-13.9-12.2-17.2-22.6l-69.9-220.1-36.7 80.8-115.3-66.4L302 819.7c4.1 8.1 9.2 13.8 15.4 17.4s11.6 3.8 16.5 1L557 703.4l-133.6-77-27-77.9-61.3 104.9Z"
                />
                <path
                    fill="#1a4e85"
                    d="m425.1 625-26.8-77.1c-.2-.8-.9-1.3-1.7-1.4-.8 0-1.5.3-1.9 1l-61.3 104.8v.2c-.8 2.1-2.4 3.7-4.5 4.4-2.4.7-5.8 0-9.8-2.4-7.7-4.5-13.2-11.7-16.3-21.5l-69.9-220.1c-.2-.8-.9-1.3-1.7-1.4-.8 0-1.6.4-2 1.2l-35.9 78.7-32.8-18.9c0 .7-.1 1.4-.4 2l-.9 1.9 34.1 19.6c.5.3 1.1.3 1.6.2.5-.2.9-.6 1.2-1.1l34.6-76L299 634.2c3.4 10.8 9.5 18.8 18.1 23.7 5 3 9.4 3.9 13 2.8s5.2-3 6.9-6.4l59.1-101 25.5 73.7c.2.5.5.9.9 1.1l95.3 54.9 1.7-3.6-94.3-54.4Z"
                />
                <path
                    fill="#bbdefb"
                    fill-rule="evenodd"
                    d="M781.9 479.2c-1.7-50.5-17.2-101.7-46.6-153.6l-3.7-6.3c-31.1-54.7-69.1-95-114-120.9-44.9-25.9-83.4-29.7-115.3-11.2L468 208.5 433.7 149c-31.9-56.1-70.4-97.1-115.3-123-44.9-25.9-82.9-28.9-114-9.1L61.1 104.1l106.1 329.3 150-91 2 239.5 150-91 124.6 188.4 150.1-91.1c26.9-22.2 39.6-58.5 38-109Z"
                />
                <path
                    fill="url(#issues_b)"
                    fill-rule="evenodd"
                    d="m593.8 679.3 150.1-91.1c5.7-4.7 10.8-10.1 15.2-16l8.3-13.4c10.7-20.7 15.6-47.2 14.5-79.6-1.7-50.5-17.2-101.7-46.6-153.6l-3.7-6.3c-31.1-54.7-69.1-95-114-120.9-44.9-25.9-83.4-29.7-115.3-11.2L468 208.5l-155.4 92.3 136.2 202.5 20.4-12.4 124.6 188.4Z"
                />
                <path
                    fill="url(#issues_c)"
                    fill-rule="evenodd"
                    d="M468 208.5 433.7 149c-31.9-56.1-70.4-97.1-115.3-123-44.9-25.9-82.9-28.9-114-9.1L61.1 104.1l6.9 21.3 250 174.1 150-91Z"
                />
                <path
                    fill="#fff"
                    fill-rule="evenodd"
                    d="M581.6 410.3c-31.1-54.7-69.1-95-114.1-120.9s-83.4-29.7-115.2-11.2L318 299.5l-34.4-59.4C251.8 184 213.4 143 168.4 117s-83-29-114-9C25 125.9 5.8 159.9 4.1 208.5s11.1 99.6 38 152.9l125.1 72 44.1-96.3c3.3-7.5 9.2-8.8 17.8-3.9s14.9 12.8 19 23.7l71.1 225 60.1-104.1c3.2-6.6 9-7.6 17.1-2.9s13.9 12.3 17.2 22.6l34.3 97.7 145.9 84.1c27-22.2 39.7-58.6 38-109.1-1.7-50.5-17.2-101.7-46.6-153.5l-3.6-6.4Z"
                />
                <path
                    fill="#1a4e85"
                    d="m475.8 296.8 3.1-2.8c-3.4-2.2-6.9-4.3-10.4-6.3-45.4-26.2-84.8-30-117.2-11.2l-32.6 20.2-33.3-57.6c-31.9-56.2-70.9-97.8-116-123.8-3.2-1.9-6.4-3.6-9.6-5.2l-1.5 3.7 9.1 5c44.4 25.6 83 66.7 114.5 122.3l34.3 59.4c.3.4.8.8 1.3.9.5.1 1 0 1.5-.2l34.3-21.3c31.1-17.9 69.2-14.2 113.2 11.2 3.2 1.8 6.3 3.7 9.3 5.7ZM587 415.7l-3.7-6.4c-8.8-15.6-18.7-30.6-29.5-44.9-1 .9-2 1.8-3.1 2.6 10.7 14.1 20.5 28.9 29.1 44.3l3.7 6.3c24.3 42.9 39.1 85.7 44.4 127.8h4c-5.2-42.7-20.3-86.2-44.9-129.7ZM449.6 593.8l-34.1-96.9c-3.4-10.8-9.5-18.8-18.1-23.7-5-2.9-9.4-3.9-13-2.8s-5.2 3.1-6.9 6.4L319.7 577 250 356.3c-4.3-11.3-11-19.6-19.9-24.7-5.2-3-9.7-3.9-13.4-2.7s-5.5 3.6-7.2 7.5l-43.2 94.3-17.2-9.9c-.6 1.2-1.3 2.3-2 3.4l19.1 11.1c.5.2 1.1.3 1.6 0 .5-.1 1-.5 1.2-1l44.1-96.4c1.3-2.9 2.9-4.6 4.9-5.3s5.9 0 10.1 2.3c8.1 4.7 14.2 12.3 18.1 22.6l71.1 225c.3.8.9 1.3 1.7 1.4.8 0 1.5-.3 1.9-1L381 478.7c1.2-2.4 2.6-3.9 4.5-4.5s5.8 0 9.8 2.5c7.7 4.4 13.2 11.6 16.3 21.5l34.3 97.6c.2.4.5.8.9 1l112.7 64.9c.7-1.1 1.6-2.1 2.4-3.2l-112.4-64.8Z"
                />
                <path
                    fill="none"
                    stroke="#1a4e85"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="8"
                    d="M781.9 479.2c-1.7-50.5-17.2-101.7-46.6-153.6l-3.7-6.3c-31.1-54.7-69.1-95-114-120.9-44.9-25.9-83.4-29.7-115.3-11.2L468 208.5 433.7 149c-31.9-56.1-70.4-97.1-115.3-123-44.9-25.9-82.9-28.9-114-9.1L61.1 104.1h0c-2.3 1.2-4.5 2.5-6.7 3.9C25 125.9 5.8 159.9 4.1 208.5s11.1 99.6 38 152.9l75.1 43.2-38.3 23.3h0L302 819.7c4.1 8.1 9.2 13.8 15.4 17.4s11.6 3.8 16.5 1L557 703.4h0l148.6-91.9 38.3-23.3c26.9-22.2 39.6-58.5 38-109Z"
                />
            </svg>
        );
    }

    renderDark() {
        return (
            <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 786 844"
                aria-hidden="true"
                width="100%"
                height="100%"
                focusable="false"
                role="img"
                part="illustration"
            >
                <defs>
                    <linearGradient
                        id="issues_b"
                        x1="936.2"
                        x2="663.2"
                        y1="50.8"
                        y2="410.1"
                        gradientTransform="matrix(1 0 0 -1 -207 642)"
                        gradientUnits="userSpaceOnUse"
                    >
                        <stop offset=".3" stop-color="#09264a" />
                        <stop offset="1" stop-color="#ced4db" />
                    </linearGradient>
                    <linearGradient
                        id="issues_c"
                        x1="570.5"
                        x2="387"
                        y1="359.7"
                        y2="601.2"
                        gradientTransform="matrix(1 0 0 -1 -207 642)"
                        gradientUnits="userSpaceOnUse"
                    >
                        <stop offset="0" stop-color="#09264a" />
                        <stop offset="1" stop-color="#ced4db" />
                    </linearGradient>
                </defs>
                <path
                    fill="#09264a"
                    d="m557 703.4 150.1-91.1-133.7-77-26.9-77.8-102.8 62.4L381 322.5l-86.2 52.3-65.8-38-150.1 91.1L275 695.3l141.3 68 47.1-20c1.3 1 2.6 1.9 4 2.7 6.1 3.6 11.7 3.9 16.6 1.1l70.7-42.7 2.3-1Z"
                />
                <path
                    fill="#ced4db"
                    fill-rule="evenodd"
                    d="M335.1 653.4c-3.2 6.6-9 7.5-17.1 2.8s-13.9-12.2-17.2-22.6l-69.9-220.1-36.7 80.8-115.3-66.4L302 819.7c4.1 8.1 9.2 13.8 15.4 17.4s11.6 3.8 16.5 1L557 703.4l-133.6-77-27-77.9-61.3 104.9Z"
                />
                <path
                    fill="#09264a"
                    d="m425.1 625-26.8-77.1c-.2-.8-.9-1.3-1.7-1.4-.8 0-1.5.3-1.9 1l-61.3 104.8v.2c-.8 2.1-2.4 3.7-4.5 4.4-2.4.7-5.8 0-9.8-2.4-7.7-4.5-13.2-11.7-16.3-21.5l-69.9-220.1c-.2-.8-.9-1.3-1.7-1.4-.8 0-1.6.4-2 1.2l-35.9 78.7-32.8-18.9c0 .7-.1 1.4-.4 2l-.9 1.9 34.1 19.6c.5.3 1.1.3 1.6.2.5-.2.9-.6 1.2-1.1l34.6-76L299 634.2c3.4 10.8 9.5 18.8 18.1 23.7 5 3 9.4 3.9 13 2.8s5.2-3 6.9-6.4l59.1-101 25.5 73.7c.2.5.5.9.9 1.1l95.3 54.9 1.7-3.6-94.3-54.4Z"
                />
                <path
                    fill="#09264a"
                    fill-rule="evenodd"
                    d="M781.9 479.2c-1.7-50.5-17.2-101.7-46.6-153.6l-3.7-6.3c-31.1-54.7-69.1-95-114-120.9-44.9-25.9-83.4-29.7-115.3-11.2L468 208.5 433.7 149c-31.9-56.1-70.4-97.1-115.3-123-44.9-25.9-82.9-28.9-114-9.1L61.1 104.1l106.1 329.3 150-91 2 239.5 150-91 124.6 188.4 150.1-91.1c26.9-22.2 39.6-58.5 38-109Z"
                />
                <path
                    fill="url(#issues_b)"
                    fill-rule="evenodd"
                    d="m593.8 679.3 150.1-91.1c5.7-4.7 10.8-10.1 15.2-16l8.3-13.4c10.7-20.7 15.6-47.2 14.5-79.6-1.7-50.5-17.2-101.7-46.6-153.6l-3.7-6.3c-31.1-54.7-69.1-95-114-120.9-44.9-25.9-83.4-29.7-115.3-11.2L468 208.5l-155.4 92.3 136.2 202.5 20.4-12.4 124.6 188.4Z"
                />
                <path
                    fill="url(#issues_c)"
                    fill-rule="evenodd"
                    d="M468 208.5 433.7 149c-31.9-56.1-70.4-97.1-115.3-123-44.9-25.9-82.9-28.9-114-9.1L61.1 104.1l6.9 21.3 250 174.1 150-91Z"
                />
                <path
                    fill="#ced4db"
                    fill-rule="evenodd"
                    d="M581.6 410.3c-31.1-54.7-69.1-95-114.1-120.9s-83.4-29.7-115.2-11.2L318 299.5l-34.4-59.4C251.8 184 213.4 143 168.4 117s-83-29-114-9C25 125.9 5.8 159.9 4.1 208.5s11.1 99.6 38 152.9l125.1 72 44.1-96.3c3.3-7.5 9.2-8.8 17.8-3.9s14.9 12.8 19 23.7l71.1 225 60.1-104.1c3.2-6.6 9-7.6 17.1-2.9s13.9 12.3 17.2 22.6l34.3 97.7 145.9 84.1c27-22.2 39.7-58.6 38-109.1-1.7-50.5-17.2-101.7-46.6-153.5l-3.6-6.4Z"
                />
                <path
                    fill="#09264a"
                    d="m475.8 296.8 3.1-2.8c-3.4-2.2-6.9-4.3-10.4-6.3-45.4-26.2-84.8-30-117.2-11.2l-32.6 20.2-33.3-57.6c-31.9-56.2-70.9-97.8-116-123.8-3.2-1.9-6.4-3.6-9.6-5.2l-1.5 3.7 9.1 5c44.4 25.6 83 66.7 114.5 122.3l34.3 59.4c.3.4.8.8 1.3.9.5.1 1 0 1.5-.2l34.3-21.3c31.1-17.9 69.2-14.2 113.2 11.2 3.2 1.8 6.3 3.7 9.3 5.7ZM587 415.7l-3.7-6.4c-8.8-15.6-18.7-30.6-29.5-44.9-1 .9-2 1.8-3.1 2.6 10.7 14.1 20.5 28.9 29.1 44.3l3.7 6.3c24.3 42.9 39.1 85.7 44.4 127.8h4c-5.2-42.7-20.3-86.2-44.9-129.7ZM449.6 593.8l-34.1-96.9c-3.4-10.8-9.5-18.8-18.1-23.7-5-2.9-9.4-3.9-13-2.8s-5.2 3.1-6.9 6.4L319.7 577 250 356.3c-4.3-11.3-11-19.6-19.9-24.7-5.2-3-9.7-3.9-13.4-2.7s-5.5 3.6-7.2 7.5l-43.2 94.3-17.2-9.9c-.6 1.2-1.3 2.3-2 3.4l19.1 11.1c.5.2 1.1.3 1.6 0 .5-.1 1-.5 1.2-1l44.1-96.4c1.3-2.9 2.9-4.6 4.9-5.3s5.9 0 10.1 2.3c8.1 4.7 14.2 12.3 18.1 22.6l71.1 225c.3.8.9 1.3 1.7 1.4.8 0 1.5-.3 1.9-1L381 478.7c1.2-2.4 2.6-3.9 4.5-4.5s5.8 0 9.8 2.5c7.7 4.4 13.2 11.6 16.3 21.5l34.3 97.6c.2.4.5.8.9 1l112.7 64.9c.7-1.1 1.6-2.1 2.4-3.2l-112.4-64.8Z"
                />
                <path
                    fill="none"
                    stroke="#fff"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="8"
                    d="M781.9 479.2c-1.7-50.5-17.2-101.7-46.6-153.6l-3.7-6.3c-31.1-54.7-69.1-95-114-120.9-44.9-25.9-83.4-29.7-115.3-11.2L468 208.5 433.7 149c-31.9-56.1-70.4-97.1-115.3-123-44.9-25.9-82.9-28.9-114-9.1L61.1 104.1h0c-2.3 1.2-4.5 2.5-6.7 3.9C25 125.9 5.8 159.9 4.1 208.5s11.1 99.6 38 152.9l75.1 43.2-38.3 23.3h0L302 819.7c4.1 8.1 9.2 13.8 15.4 17.4s11.6 3.8 16.5 1L557 703.4h0l148.6-91.9 38.3-23.3c26.9-22.2 39.6-58.5 38-109Z"
                />
            </svg>
        );
    }
}
